module.exports = __webpack_public_path__ + "static/media/steering-wheel-1130626_640.bdfd13a1.jpg";